import PropTypes from 'prop-types';
import { getProfilePic,downloadFile } from 'functions/fileUpload';
import { useEffect, useState } from 'react';
import { getAttachmentsByTicketDetailId } from 'functions/ticket';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import classNames from 'classnames';

const File = ({ icon, title, action, actionIcon, className,fileNo,fileType }) => {
    return (
      <div
        className={classNames(
          'border p-2 rounded-3 d-flex bg-white dark__bg-1000 fs--1',
          className
        )}
        onClick={()=>{
          downloadFile(fileNo,fileType);
        }}
      >
        <FontAwesomeIcon icon={icon} className="fs-1" />
        <span className="ms-2 me-3">{title}</span>
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip style={{ position: 'fixed' }}>{action}</Tooltip>}
        >
          <a href="#!"  className="text-300 ms-auto">
            <FontAwesomeIcon icon={actionIcon} />
          </a>
        </OverlayTrigger>
      </div>
    );
  };
  
  File.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    title: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    actionIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
      .isRequired,
    className: PropTypes.string
  };

const Attachments=({ticketDetailId})=>{

    const [attachments,setAttachments]=useState([]);
    const [isDownloadingAll,setIsDownloadingAll]=useState(false);
    useEffect(()=>{
      loadAttachments();
  
    },[])
    const loadAttachments = async () => {
      try {
        const token=localStorage.getItem('token');
        const data = await getAttachmentsByTicketDetailId(ticketDetailId,token);
       // console.log('getAttachmentsByTicketDetailId', data);
        const attachments=[];
        data.map(o=>{
          attachments.push({
            ticketMasterAttachmentsId:o.TicketMasterAttachmentsId,
            ticketDetailId:o.TicketDetailId,
            fileType:o.FileType,
            oriFileName:o.OriFileName,
            fileSize:o.FileSize,
            fileNo:o.FileNo
          });
        })
        setAttachments(attachments);
      } catch (err) {
        console.log('Error', err);
      }
    };

    return (
        <>
            {attachments.length>0 && (
          <div className="p-3 bg-light rounded-3 mt-2">
            <div className="d-inline-flex flex-row">
             
             {attachments.map(a=>{
                return (
                  <div style={{margin:'1px'}}>
                  <File
                    title={`${a.oriFileName} (${a.fileSize})`}
                    icon='file-archive'
                    action="Download"
                    actionIcon="arrow-down"
                    className="mb-2"
                    fileNo={a.fileNo}
                    fileType={a.fileType}
                  />
                  </div>
                );

             })}

            </div>
            <hr className="my-x1" />
            <Row className="flex-between-center gx-4 gy-2">
              <Col xs="auto">
                <p className="fs--1 text-1000 mb-sm-0 font-sans-serif fw-medium mb-0">
                  <FontAwesomeIcon icon="link" className="me-2" />{`${attachments.length} Files `}
                  attached
                </p>
              </Col>
              <Col xs="auto">
                <IconButton
                  icon="file-download"
                  variant="falcon-default"
                  size="sm"
                  onClick={()=>{

                    try{
                    setIsDownloadingAll(true);
                    attachments && attachments.map(async m=>{ 
                    await downloadFile(m.fileNo,m.fileType);
                    })
                    setIsDownloadingAll(false);
                  }
                  catch(err){
                    setIsDownloadingAll(false);
                    console.log('Error:',err);
                    message("Error",err,"error");
                  }

                  }}
                >
                  <span className="ms-1">Download all</span>
                </IconButton>
              </Col>
            </Row>
            {/* {JSON.stringify(attachments)} */}
          </div>
        )}
        </>
    )
}

export default Attachments;